import React from 'react'
import { Typography } from '@material-ui/core'

import clsx from 'clsx'

export default (props) => {
  const { id, name, style = {} } = props
  const { text = 'text-12' } = style
  return (
    <Typography
      component="span"
      id={`topics-${id}`}
      className={clsx(text, 'font-400 text-primary-300 text-12')}
      {...props}
    >
      # {name}
    </Typography>
  )
}
